"use client";

import { ArrowLeft } from "lucide-react";

import { Button } from "../../../shadcn/ui/button";

export function MobileCancelConfirmScreen({
  onBack,
  onConfirm,
  isCancelling,
}: {
  onBack: () => void;
  onConfirm: () => void;
  isCancelling: boolean;
}) {
  return (
    <div className="flex flex-col h-full px-6 py-6">
      <button
        type="button"
        onClick={onBack}
        className="flex items-center gap-1 text-sm text-[#787B7E] mb-6"
      >
        <ArrowLeft className="h-4 w-4" />
        Back
      </button>
      <h3 className="text-xl font-semibold text-[#29333C]">
        Cancel your subscription?
      </h3>
      <p className="mt-3 text-sm text-[#787B7E]">
        Your remaining credits stay available, but you won&apos;t receive new
        credits next month. You can resubscribe any time.
      </p>
      <div className="flex flex-col gap-3 mt-auto">
        <Button
          variant="outline"
          className="w-full"
          onClick={onBack}
          disabled={isCancelling}
        >
          Keep subscription
        </Button>
        <Button
          variant="destructive"
          className="w-full"
          onClick={onConfirm}
          disabled={isCancelling}
        >
          {isCancelling ? "Cancelling..." : "Cancel subscription"}
        </Button>
      </div>
    </div>
  );
}
